import React from 'react';
import styled from 'styled-components/macro';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';
import { usePromotions } from 'src/client/helpers/usePromotions';
import { AD_ZONE_HEADER_RIBBON } from 'src/client/constants/joinCampaigns';
import { PromotionRibbonMessage } from 'src/client/redux/modules/app';

// Configure the database row as `promotions.ribbonMessagesJSON`.
// Example value:
// [
//   { "text": "HOLIDAY SALE, ONLY 9.95! - LIMITED TIME OFFER!!" },
//   { "text": "NEW YEARS SALE, ONLY 9.95! - FINAL DAY!!", "startAt": "2025-12-31T08:00:00.000Z" }
// ]
// Messages without `startAt` act as the default. When multiple messages exist, the latest
// message whose `startAt` is in the past becomes the ribbon text.
const getPromoHeaderRibbonText = (messages?: PromotionRibbonMessage[]) => {
  if (!messages?.length) {
    return '';
  }

  const now = Date.now();

  const [latestMessage] = messages
    .map((message) => ({
      startAtMs: message.startAt ? new Date(message.startAt).getTime() : Number.NEGATIVE_INFINITY,
      text: message.text,
    }))
    .filter((message) => message.text && message.startAtMs <= now)
    .sort((left, right) => right.startAtMs - left.startAtMs);

  return latestMessage?.text || '';
};

export const PromoHeaderRibbon = () => {
  const { isPromoRibbonActive, ribbonMessages } = usePromotions();
  const [joinHref] = useJoinUrl({ campaign: AD_ZONE_HEADER_RIBBON });
  const ribbonText = getPromoHeaderRibbonText(ribbonMessages);

  if (!isPromoRibbonActive || !ribbonText) {
    return null;
  }

  return (
    <PromoHeaderRibbonContainer>
      <PromoHeaderRibbonLink href={joinHref}>{ribbonText}</PromoHeaderRibbonLink>
    </PromoHeaderRibbonContainer>
  );
};

const PromoHeaderRibbonContainer = styled.div`
  align-items: center;
  background-color: #ceab58;
  display: flex;
  justify-content: center;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  min-height: 40px;
  padding: 4px 0;
  text-align: center;

  @media ${TABLET_PORTRAIT} {
    font-size: 16px;
  }
`;

const PromoHeaderRibbonLink = styled.a`
  color: #000;
  display: block;
  margin: 0 2px;
  text-align: center;
  text-decoration: none;

  &:hover {
    color: #e6e6e6;
    text-decoration: underline;
  }
`;
